import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";

import Management from "../Ordermanagment/Food/Management";
import Orders from "../Ordermanagment/Food/Orders";
import MobileOrderspage from "../Ordermanagment/Food/MobileOrderspage"
import './Ordermanagment.css'
const Foodordermanagment = () => {
    const [activeCategory, setActiveCategory] = useState("Overview");

    const isMobile = window.innerWidth <= 768;


    return (
        <div>
            {/* Breadcrumb */}


            <div className="container-fluid">
                <div className="row">
                    <div className="row" style={{ marginTop: "40px" }}>
                        {/* Left Column */}
                        <div className="col-lg-2 order-management-data">
                            <MobileOrderspage />
                        </div>

                        {/* Middle Column */}
                        <div
                            className="col-lg-7 col-md-7 col-sm-12 col-12 "
                            style={{ paddingLeft: "0px", paddingRight: "0px" }}
                        >
                            <p
                                className="breadcrumb maamaas-home-bredcum"
                                style={{
                                    position: "fixed",
                                top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "55px" : "64px" ,                            
                                    left: "2vw",
                                    width: "100%",
                                    backgroundColor: "#fff",
                                    zIndex: 1000,
                                    padding: "10px 0",
                                    fontSize: isMobile ? "16px" : "18px",
                                    fontWeight: isMobile ? "normal" : "bold",
                                    textAlign: "center",
                                    margin: 0,
                                }}
                            >
                                {/* <Link
                                    to="/Newmainlandingpage"
                                    style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                                >
                                    Home
                                </Link> */}
                                {/* <span className="separator"> &gt; </span> */}
                                <Link
                                    to="/fooddashboard"
                                    style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                                >
                                    Food & Beverages
                                </Link>
                                <span className="separator"> &gt; </span>
                                <Link

                                    style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                                >
                                    Order Management
                                </Link>

                            </p>
                            <div style={{ borderRadius: "8px" }} className="order-management-data">
                                {activeCategory === "Overview" && <Management />}
                                {/* {activeCategory === "Closed" && <Closed />}
                                {activeCategory === "Pending" && <Pending />}
                                {activeCategory === "Food" && <Food />} */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Column */}
            <div className="col-lg-3">
                <Orders />
            </div>
        </div>
    );
};

export default Foodordermanagment;
